module.exports = __webpack_public_path__ + "img/big-2.d7ebc43a.png";